export const navbarNavigation = (function ($) {

    let navbarItemOpen = "js-open-sub-menu";
    let $navbarItem = $(".menu-item-has-children"); // using wordpress class as selector
    let $navbarItemMobile = $(".menu-item-has-children a"); // using wordpress class as selector
    let $navbarItemBack = $(".menu-item--back");

    function init() {

        // mouseover and mouseout functions only
        if (window.matchMedia('(min-width: 768px)').matches) {
            $navbarItem.on("mouseover", function () {
                $(this).addClass(navbarItemOpen);
            });
            $navbarItem.on("mouseout", function () {
                $(this).removeClass(navbarItemOpen);
            });
        } else {
            $navbarItemMobile.on("click", function () {
                // using parent() because on mobile we target the <a> taginstead of the <li> tag
                $(this).parent().addClass(navbarItemOpen);
            });
            $navbarItemBack.on("click", function (e) {
                e.preventDefault();
                $('.'+navbarItemOpen).removeClass(navbarItemOpen);
            });
        }
    }

    // function toggleMenuItem(e){
    //     e.preventDefault();
    //     let $navbarItemOpen = document.querySelector("."+navbarItemOpen);
    //     let sameElem = false;
    //     if ($navbarItemOpen){
    //         closeMenuItem($navbarItemOpen);
    //         sameElem = $navbarItemOpen === e.target;
    //     }
    //     if (!sameElem){
    //         let panel = e.target;
    //         openMenuItem(panel);
    //     }
    // }

    // function closeMenuItem($navbarItemOpen){
    //     $navbarItemOpen.classList.remove(navbarItemOpen);
    // }
    //
    // function openMenuItem(panel){
    //     panel.classList.add(navbarItemOpen);
    // }
    //
    // function closeMenuBack(e){
    //     e.preventDefault();
    //     let $navbarItemOpen = document.querySelector("."+navbarItemOpen);
    //     $navbarItemOpen.classList.remove(navbarItemOpen);
    // }

    return {
        init: init
    }

})(jQuery);
